import { cn } from '@sohanemon/utils';
import { localizeDigits } from '@sohanscript/lib/utils/format';
import { useSohanEmon } from '#/lib/hooks/sohanemon.tsx';

type ResumeEducationProps = React.ComponentProps<'div'>;

export function ResumeEducation({ className, ...props }: ResumeEducationProps) {
	const { education } = useSohanEmon();

	return (
		<div className={cn(className)} {...props}>
			<p className="mb-0.5 font-semibold text-foreground text-xs leading-tight">
				{education.degree}
			</p>
			<p className="mb-0.5 text-muted-foreground text-xs">
				{education.institution}
			</p>
			<p className="mb-2 font-mono text-3xs text-muted-foreground">
				{localizeDigits(education.period)}
			</p>
			<p className="text-2xs text-muted-foreground leading-relaxed">
				{education.description}
			</p>
		</div>
	);
}
